import { z } from 'zod';

export const VenueTag = z.enum([
  'HAS_PROMOTIONS',
  'ENVIRONMENTALLY_FRIENDLY',
  'TOP_AWARDED',
  'HAS_NEED_DATES',
  'PASSKEY_ENABLED',
  'SOCIAL_TABLES_ENABLED',
  'SAFETY_INFO',
  'HAS_3D_DIAGRAMS',
  'HAS_VIDEO'
]);

export type VenueTag = z.infer<typeof VenueTag>;
